import { Type } from "./type";
import { orderRepository } from "../repositories";
export const orderModule = {
  namespaced: true,
  state: () => ({
    loading: false,
    data: [],
  }),
  getters: {
    list: (state) => state.data,
  },
  mutations: {
    [Type.ORDER_GET_ALL_SUCCESS](state, payload) {
      payload = payload.map((item) => {
        return { ...item, expand: false };
      });
      state.data = [...payload];
    },
    [Type.ORDER_GET_ALL_FAILURE](_, payload) {
      console.log(payload);
    },
    [Type.EXPAND_TOGGLE](state, payload) {
      let targetIndex = state.data.findIndex((item) => item.id == payload);
      state.data[targetIndex].expand = !state.data[targetIndex].expand;
    },
  },
  actions: {
    async [Type.ORDER_GET_ALL_ASYNC]({ commit }, payload = null) {
      try {
        const { data } = await orderRepository.getAll();
        commit(Type.ORDER_GET_ALL_SUCCESS, data?.data?.result);
      } catch (error) {
        commit(Type.ORDER_GET_ALL_FAILURE, error);
      }
    },
  },
};
